import { render } from "./AppFormItem.vue?vue&type=template&id=75680419&scoped=true"
import script from "./AppFormItem.vue?vue&type=script&lang=js"
export * from "./AppFormItem.vue?vue&type=script&lang=js"

import "./AppFormItem.vue?vue&type=style&index=0&id=75680419&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75680419"]])

export default __exports__